
import { mapState, mapGetters, mapActions } from 'vuex';
import { LIKE_ANIMATION_DURATION } from '@/constants/SHORTS_POPUP';
import LikeScore from '@/enums/LikeScore';
import SpamReportDialog from './SpamReportDialog';

export default {
  i18nComponentKey: 'ReviewsShortsPopup.components.ActionButtons',
  name: 'ActionButtons',
  props: {
    review: { type: Object, required: true },
    reviewIndex: { type: Number, default: null },
    mediaPosition: { type: Number, default: null },
    popupParams: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      isLikeIconAnimating: false,
      animationTimeout: null,
      showMorePopover: false
    };
  },
  computed: {
    ...mapGetters('widget', ['isPcViewport']),
    ...mapState('like', ['isLoadingLike']),
    ...mapState('window', ['windowService']),
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapGetters('like', ['currentPlusLikesCount']),
    ...mapGetters('widget', ['shortsReviewPopupUrlForShare']),
    showLikeButton() {
      return this.reviewSettings && this.reviewSettings.use_likes_count;
    },
    liked() {
      return this.review.like_score === LikeScore.LIKE;
    },
    likeAnimationStyle() {
      return {
        '--like-animation-duration': `${LIKE_ANIMATION_DURATION}ms`
      };
    }
  },
  watch: {
    liked(newVal, oldVal) {
      if (newVal && !oldVal) this.startAnimation();
    }
  },
  beforeDestroy() {
    if (this.animationTimeout) {
      clearTimeout(this.animationTimeout);
    }
  },
  methods: {
    ...mapActions('like', ['toggleLike']),
    ...mapActions('bottomSheet', ['openBottomSheet']),
    startAnimation() {
      this.isLikeIconAnimating = true;
      if (this.animationTimeout) {
        clearTimeout(this.animationTimeout);
      }
      this.animationTimeout = setTimeout(() => {
        this.isLikeIconAnimating = false;
      }, LIKE_ANIMATION_DURATION);
    },
    onClickLike() {
      if (this.isLoadingLike) return;

      this.toggleLike({ review: this.review });
    },
    onClickShare() {
      const url = this.shortsReviewPopupUrlForShare(
        this.review.id,
        this.mediaPosition,
        this.reviewIndex,
        this.popupParams,
        this.review.product_code
      );

      this.windowService.share({
        title: this.review.product_name,
        url: encodeURIComponent(url)
      });
    },
    onClickMore() {
      if (this.isPcViewport) {
        this.showMorePopover = !this.showMorePopover;
        return;
      }

      this.openBottomSheet({
        component: SpamReportDialog,
        props: {
          reviewId: this.review.id
        }
      });
    }
  }
};
